import React from "react";
import { Container, TitleLine, SubTitleLine } from "./Styled";

type TitleProps = {
  title: string;
  subTitle?: string;
  titleSize?: "small" | "medium";
};

const Title: React.FunctionComponent<TitleProps> = ({ title, subTitle, titleSize }) => {
  return (
    <Container>
      <TitleLine size={titleSize}>{title}</TitleLine>
      {subTitle ? <SubTitleLine>{subTitle}</SubTitleLine> : null}
    </Container>
  );
};

export default Title;
